import $ from "jquery";
import "jquery-ui-dist/jquery-ui";
import moment from "moment";
import * as bootbox from "bootbox";
import Ajax from "DMS/Seed/Seed.Ajax";
import Tab from "DMS/Seed/Seed.Tab";
import Form from "DMS/Seed/Seed.Form";
import { openModalIframe, closeModalIframe, notify } from "DMS/Utils/modal";
import { resizeScreen } from "DMS/Utils/resizeScreen";
import { escapeSelector, json2array } from "DMS/Utils/lib";
import { refreshPlanningAndList } from "DMS/Controllers/planningController";
import { toggleTraffic, formatTime } from "DMS/Controllers/geolocController";
import Seed from "./All";
class Planning {
    constructor() {
        this.tempsDistanceRight = true;
        this.zonesRouges = true;
        this.Unit = 17;
        this.Date = [];
        this.Mode = [];
        this.Secteur = [];
        this.Activite = [];
        this.Lock = [];
        this.NumDossier = [];
        this.taskParent = {};
        this.currentTask = {
            currentLength: 0
        };
        this.nextSibling = {};
        this.planning_cart = false;
        this.Clipboard = null;
    }
    /**
    * Chargement Plannning (Mode Semaine)
    * @param {[type]} pDate           [description]
    * @param {[type]} pCodetechnicien [description]
    * @param {[type]} pDossier        [description]
    */
    LoadWeek(pDate, pCodetechnicien, pDossier, pSecteur, tacheStdOrDetail, planningTypeSemaine) {
        Ajax.Post({
            url: "_module/Planning/Planning.Week.php",
            data: "numtab=" + Tab.cTab.attr("id")
                + "&date=" + pDate
                + "&codetechnicien=" + pCodetechnicien
                + "&secteur=" + pSecteur
                + "&dossier=" + pDossier
                + "&tacheStdOrDetail=" + tacheStdOrDetail
                + "&planningTypeSemaine=" + planningTypeSemaine,
            json: true,
            async: true,
            success: (xml) => {
                delete this.currentTask.realParent;
                resizeScreen();
                this.Date[Tab.cTab.attr("id")] = pDate;
                Tab.GetFrame().find("#Planning").html(xml["html"]);
                var jscript = document.createElement("SCRIPT");
                jscript.text = xml.script;
                Tab.GetFrame().append(jscript);
                Tab.GetFrame().find(jscript).remove();
                this.formatData();
                Tab.GetFrame().find(".selectable").selectable(this.getSelectableAttr(pDate, pCodetechnicien, pSecteur, tacheStdOrDetail, planningTypeSemaine));
                this.useDroppable();
                this.lockingJqueryUI(this.getLock());
            }
        });
    }
    /**
     * Chargement Plannning (Mode Jour pour tous les technicien)
     * @param pDate             Filtre sur date
     * @param pCodetechnicien   Filtre sur code technicien
     * @param pDossier          Filtre sur num dossier
     * @param pSecteur          Filtre sur secteur
     */
    LoadDayAll(pDate, pCodetechnicien, pDossier, pSecteur, competence) {
        Ajax.Post({
            url: "_module/Planning/Planning.DayAll.php",
            data: "numtab=" + Tab.cTab.attr("id")
                + "&date=" + pDate
                + "&codetechnicien=" + pCodetechnicien
                + "&dossier=" + pDossier
                + "&secteur=" + pSecteur
                + "&competence=" + competence,
            json: true,
            async: true,
            success: (xml) => {
                delete this.currentTask.realParent;
                resizeScreen();
                this.Date[Tab.cTab.attr("id")] = pDate;
                this.Secteur[Tab.cTab.attr("id")] = pSecteur;
                Tab.GetFrame().find("#Planning").html(xml["html"]);
                var jscript = document.createElement("SCRIPT");
                jscript.text = xml.script;
                Tab.GetFrame().append(jscript);
                Tab.GetFrame().find(jscript).remove();
                this.formatData();
                Tab.GetFrame().find(".selectable").selectable(this.getSelectableAttr(pDate, pCodetechnicien, pSecteur, '', ''));
                this.useDroppable();
                this.lockingJqueryUI(this.getLock());
            }
        });
    }
    formatData() {
        var items = Tab.GetFrame().find('[data-dateFormat]');
        for (var i = 0, len = items.length; i < len; i++) {
            var text = Tab.GetFrame().find(items[i]).text();
            var attr = Tab.GetFrame().find(items[i]).attr('data-dateFormat');
            if (text) {
                var attrTmp = moment.localeData().longDateFormat(attr);
                if (attrTmp) {
                    attr = attrTmp.replace(moment.localeData().longDateFormat('LT'), '').trim();
                }
                var dateMoment = moment.utc(text);
                if (dateMoment.isValid()) {
                    text = dateMoment.format(attr);
                    Tab.GetFrame().find(items[i]).text(text);
                    Tab.GetFrame().find(items[i]).removeAttr('data-dateFormat');
                }
            }
        }
    }
    setDragAndDrop() {
        $('.tacheDay').on("dragstart", (event) => {
            this.taskParent = $(event.target).parent();
            this.currentTask = $(event.target);
            this.currentTask.startPosition = $(event.target).position();
        });
    }
    /**
     * Use Jquery droppable option
     * Tache planifiee
     */
    useDroppable() {
        this.setDragAndDrop();
        // Tache à planifier
        Tab.GetFrame().find(".tacheDroppable").droppable({
            drop: (event, ui) => {
                var eventTargetJqueryObj = Tab.GetFrame().find(event.target);
                this.currentTask.hasBeenDropped = true;
                this.taskParent = event.target;
                this.currentTask.day = eventTargetJqueryObj.attr("data-date");
                this.currentTask.numDay = eventTargetJqueryObj.attr("data-numDay");
                this.currentTask.codeTech = eventTargetJqueryObj.attr("data-tech");
                var hour = Tab.GetFrame().find(event.target).attr("id");
                // 2 demi-heures
                var length = this.currentTask.currentLength;
                var pCodetechnicien = Tab.GetFrame().find(event.target).attr("data-tech");
                var pDossier = Tab.GetFrame().find(ui.draggable).find('div[name="numdossier"]').text();
                if (this.currentTask.isFrom === undefined) {
                    Ajax.Post({
                        url: "_module/Planning/Planning.Week.CreateTask.php",
                        data: "hour=" + hour
                            + "&length=" + length
                            + "&codetechnicien=" + pCodetechnicien
                            + "&numdossier=" + pDossier
                            + "&isFromCart=true",
                        json: true,
                        async: true,
                        success: (xml) => {
                            if (xml.taskLength === -1) {
                                bootbox.alert(xml.errorMsg);
                            }
                            else {
                                Process(3030, json2array(xml), null, null).then(() => this.totalRefresh());
                            }
                        }
                    });
                }
            }
        });
    }
    /**
     * Initialisation du planning
     * @param {type} Mode Mode d'affichage
     * @param {type} secteur secteur en filtre
     * @returns {undefined}
     */
    Init(Mode, secteur, activite, numdossier) {
        resizeScreen();
        // on enregistre le numero du dossier courant pour pouvoir planifier plusieurs fois
        // un meme dossier (clic sur le planning) malgre les rafraichissements du planning entre les planifications
        this.SetNumDossier(numdossier);
        this.Mode[Tab.cTab.attr("id")] = Mode;
        this.Secteur[Tab.cTab.attr("id")] = secteur;
        this.Activite[Tab.cTab.attr("id")] = activite;
        Tab.GetFrame().find(".Hour").click((event) => this.LoadTask(Tab.GetFrame().find(event.target).attr("id"), 2));
    }
    /**
     * Retourne le mode d'affichage
     * @returns {string} Mode d'affichage. jour , jourdetail,
     * semaine, semaindetail, mois
     */
    GetMode() {
        return this.Mode[Tab.cTab.attr("id")];
    }
    SetMode(mode) {
        this.Mode[Tab.cTab.attr("id")] = mode;
    }
    /**
     * Retourne le secteur selectionné
     * @returns {string} Code du secteur
     */
    GetSecteur() {
        return this.Secteur[Tab.cTab.attr("id")];
    }
    GetNumDossier() {
        return this.NumDossier[Tab.cTab.attr("id")];
    }
    // fonction pour enregistrer un numero de dossier : utile pour pour pouvoir planifier plusieurs fois
    // un meme dossier (clic sur le planning) malgre les rafraichissements du planning entre les planifications
    SetNumDossier(numdossier) {
        return this.NumDossier[Tab.cTab.attr("id")] = numdossier;
    }
    /**
     * Retourne l'heure de départ et de fin de la tache
     * @param {type} task
     * @param {type} taskLength
     * @returns {Array} Heure de début, Heure de fin
     */
    GetStartHour(taskJqueryObj, taskLength) {
        var parentId = "";
        if (this.currentTask.realParent !== undefined) {
            parentId = Tab.GetFrame().find(this.currentTask.realParent).attr("id");
        }
        else {
            parentId = taskJqueryObj.parent().attr('id');
        }
        var splittedId = parentId.split('-');
        var hourString = moment.utc(this.idToDate(splittedId[0]));
        var endHourString = moment.utc(this.idToDate(splittedId[0])).add((taskLength * 15), "minutes");
        return [hourString, endHourString];
    }
    GetSimpleHour(hours) {
        return [hours[0].format('HH:mm'), hours[1].format('HH:mm')];
    }
    /**
     * Renseigne l'heure, le temps de trajet et les kms sur la tache
     * @param {type} task Tache à traiter
     * @returns {undefined}
     */
    TaskInfo(startDate, endDate, temps, distance) {
        let htmlTaskHeaderText = '';
        temps = temps || 0;
        distance = distance || 0;
        htmlTaskHeaderText = startDate.format('LT') + " - " + endDate.format('LT');
        if (distance > 0 || temps > 0) {
            htmlTaskHeaderText += " &bull; ";
            if (distance > 0) {
                htmlTaskHeaderText += Math.round(distance / 1000) + ' km';
                if (temps > 0) {
                    htmlTaskHeaderText += " - ";
                }
            }
            if (temps > 0) {
                htmlTaskHeaderText += formatTime(temps);
            }
        }
        return htmlTaskHeaderText;
        // $(task).find(".task-header").html(htmlTaskHeaderText);
    }
    /**
     * Cut a task
     * @param {number} taskId Task identifier
     * @param {string} startDateTimeStr task start date as a string
     * @param {string} endDateTimeStr task end date as a string
     * @returns {undefined}
     */
    Cut(taskId, startDateTimeStr, endDateTimeStr) {
        if (this.taskDateValidation(startDateTimeStr, endDateTimeStr)) {
            Seed.Planning.currentTask.currentLength = Seed.Planning.GetLength(taskId);
            this.Clipboard = Tab.GetFrame().find("#" + escapeSelector(taskId));
            this.Clipboard.hide();
            closeModalIframe();
        }
    }
    /**
     * Enregistre une tache
     * @param {type} task
     * @returns {undefined}
     */
    async SaveTask(task) {
        let taskJqueryObj = Tab.GetFrame().find(task);
        let parent = '';
        let taskLength = 0;
        if (this.currentTask.currentLength !== 0 && this.currentTask.currentLength !== undefined) {
            taskLength = this.currentTask.currentLength;
        }
        else {
            taskLength = await this.GetLength(taskJqueryObj.attr('id'));
        }
        if (this.currentTask.realParent !== undefined) {
            parent = this.currentTask.realParent;
        }
        else {
            parent = taskJqueryObj.parent();
        }
        return new Promise((resolve) => {
            Ajax.Post({
                url: '_module/Planning/Planning.SaveTask.php',
                data: "id=" + taskJqueryObj.attr("id")
                    + "&day=" + $(parent).attr("data-date")
                    + "&tasklength=" + taskLength
                    + "&hours=" + this.GetSimpleHour(this.GetStartHour(taskJqueryObj, taskLength))
                    + "&codetechnicien=" + $(parent).attr("data-tech"),
                json: true,
                success: (xml) => {
                    // on peut deplacer la tache si le dossier n'est pas clos,
                    // que les heures de debut et de fin sont coherentes,
                    // et s'il n'y a pas de chevauchements
                    if (xml.taskLength !== -1
                        && (xml.dossierclos == 0 || xml.dossierclos == null)) {
                        var param = json2array(xml);
                        delete this.currentTask.originalLength;
                        Process(8136, param, null, null).then(resolve);
                    }
                    else {
                        bootbox.alert(xml.errorMsg);
                        this.currentTask.currentLength = this.currentTask.originalLength;
                        this.Refresh($(task).attr("id")).then(resolve);
                        delete this.currentTask.currentLength;
                    }
                }
            });
        });
    }
    /**
     * Recupère la couleur d'une tache, par rappoort à sa catégorie
     * @param {type} Id Identifiant de la tache
     * @returns {String} Nom de la couleur
     *
     * @todo : catch if error
     */
    GetColor(Id) {
        return Ajax.Post({
            url: "_module/Planning/Planning.GetColor.php",
            data: "planningweb=" + Id,
            async: true
        });
    }
    /**
    * Recupere les donnees des taches a mettre a jour
    * (notamment kms et temps de deplacement)
    * @param {void} void
    * @returns {json} donnees issues de la bdd
    *
    * @todo : Async / Await
    */
    GetTour(filters) {
        return Ajax.Post({
            url: "_module/Planning/Planning.GetTour.php",
            data: "date=" + filters.date.value + "&codetechnicien=" + filters.nomtechnicien.value
            // Protéger la variable (si le tech a un espace ou des caractères SQL dans son nom ?) + codetechnicien != nomtechnicien
        });
    }
    /**
     * Récupère le commentaire d'une tache + nom et adresse client
     * @param {type} Id Identifiant de la tache
     * @returns {String} Commentaire
     *
     * @todo : catch if error
     */
    GetText(Id) {
        return Ajax.Post({
            url: "_module/Planning/Planning.GetText.php",
            data: "planningweb=" + Id,
            async: true
        });
    }
    /**
     * Récupère l'heure et le technicien d'une tache
     * et les temps et kms entre l'adresse precedente et la tache courante
     * @param {type} Id Identifiant d'une tache
     * @returns {json} heure et technicien, temps et kms :
     * 		{ 'startHourTech' => Y_m_dxH_i_s + '-' + codetechnicien,
     *		  'time' => temps_int,
     *		  'kms' => distance_int }
     */
    GetStartHourTechAndTimeKms(Id) {
        return Ajax.Post({
            url: "_module/Planning/Planning.GetStartHourTechAndTimeKms.php",
            data: "planningweb=" + Id,
            async: true
        });
    }
    /**
     * Récupère le temps en 1/4 heure d'une tache
     * @param {type} Id Identifiant d'une tache
     * @returns {String} Temps d'une tache, en quart d'heure
     */
    async GetLength(Id) {
        return await Ajax.Post({
            url: "_module/Planning/Planning.GetLength.php",
            data: "planningweb=" + Id,
            async: true
        });
    }
    /**
     * Rafraichit les informations d'une tachetaskInfo
     * @param {type} Id Identifiant d'une tache
     */
    Refresh(Id) {
        delete this.currentTask.realParent;
        return new Promise((resolve2) => {
            // Chercher pour éviter la cascade de callback promise
            this.GetColor(Id).then((Color) => {
                this.GetText(Id).then((taskCommentAndClientNameAndAddress_json) => {
                    new Promise((resolve) => {
                        if (this.currentTask.currentLength !== 0 && this.currentTask.currentLength !== undefined) {
                            resolve(this.currentTask.currentLength);
                        }
                        else {
                            this.GetLength(Id).then(resolve);
                        }
                    }).then((Length) => {
                        let $taskDomElement = Tab.GetFrame().find('#' + escapeSelector(Id));
                        if (!$taskDomElement.hasClass('tacheWeek')) {
                            this.GetStartHourTechAndTimeKms(Id).then((startHourTechAndTimeKms_json) => {
                                let startHourTechAndTimeKms_obj = JSON.parse(startHourTechAndTimeKms_json);
                                let taskCommentAndClientNameAndAddress_obj = JSON.parse(taskCommentAndClientNameAndAddress_json);
                                $taskDomElement.remove();
                                this.LoadTask(startHourTechAndTimeKms_obj.startHourTech, Length, Id, Color, taskCommentAndClientNameAndAddress_obj.taskComment, taskCommentAndClientNameAndAddress_obj.clientNameAndAddress, startHourTechAndTimeKms_obj.time, startHourTechAndTimeKms_obj.kms, startHourTechAndTimeKms_obj.addressmatch)
                                    .then(resolve2);
                            });
                        }
                        else {
                            $taskDomElement.css("background-color", Color);
                            resolve2();
                        }
                    });
                });
            });
        });
    }
    /**
     * Creation de la tache visuellement pour le calendrier quotidien
     * La tache commence et fini le même jour.
     *
     * @param Hour identifiant de la zone heure lié au technicien
     * @param Length Longueur de la tache (en demi-heure)
     * @param Id Identifiant de la tache (bbmindex)
     * @param Color Couleur de l'activité
     * @param Text  Descriptif de la tache
     * @param temps  temps entre adresse tache precedente et adresse tache courante
     * @param distance  distance entre adresse tache precedente et adresse tache courante
     * @param addressmatch  peut prendre 3 valeurs en fonction du retour de l'api google maps
     * 	'zero' : l'adresse n'a pas ete trouvee, pas de proposition
     * 	'partial' : google maps ne trouve pas de correspondance avec une adresse existante,
     * 		mais en propose une (ex. centre de la ville). L'adresse proposee est stockee en base (formattedaddress)
     * 	'exact' : google maps trouve l'adresse exacte ou une correspondance avec une adresse existante (interpretation)
     * @param flagData
     */
    LoadTask(Hour, Length, Id, Color, Text, nomEtAdresseClient, temps, distance, addressmatch, flagData) {
        let promise1 = new Promise((resolve) => {
            // Initialisation de Hauteur et taille de la grille
            var dateDebut = moment.utc(this.idToDate(Hour));
            var dateFin = moment.utc(dateDebut).add((Length * 15), "minutes");
            if (dateDebut.date() !== dateFin.date()) {
                dateFin = dateFin.startOf('day');
                Length = moment.duration(dateFin - dateDebut).asMinutes() / 15;
            }
            let tdToGetWidth = Tab.GetFrame().find('td:not(":first")')[0];
            this.realTaskWidth = parseInt($(tdToGetWidth).width());
            var realTaskHeight = this.Unit;
            var TaskHeight = Length * realTaskHeight;
            let htmlTaskHeaderClass = 'task-header TaskTime';
            if (addressmatch == 'zero') {
                htmlTaskHeaderClass += ' invalidAddress';
            }
            // Definition d'une tache
            // pour le div de classe task-header :
            var html = "<div draggable='true' class='tacheDay' style='height:" + TaskHeight + "px; width:"
                + this.realTaskWidth + "px; background-color:" + Color + ";'><div class='"
                // pour l'affichage permanent du nom du client et de son adresse, independamment du texte libre
                // de la tache
                //		+ htmlTaskHeaderClass + "' style='margin-right: 0px;'></div><div>"
                //		+ nomEtAdresseClient + "</div><text>" + (Text) + "</text></div>";
                + htmlTaskHeaderClass + "' style='margin-right: 0px;'></div><text>"
                + (Text) + "</text></div>";
            var Task = $(html);
            var hourElement = Tab.GetFrame().find("[id^='" + Hour + "']");
            $(hourElement).append(Task);
            Task.css("top", Tab.GetFrame().find(hourElement).position().top);
            Task.attr("id", Id);
            // Renseigne l'heure sur la tache + les temps et kms entre la tache precedente et la tache courante
            $(Task).find(".task-header").html(this.TaskInfo(dateDebut, dateFin, temps, distance));
            // Ajoute les pastilles sur les taches
            if (flagData !== 'null' && flagData !== undefined) {
                this.appendPastile(Id, flagData);
            }
            else {
                this.appendPastile(Id, "");
            }
            Task.bind("click", (event) => this.ShowTask($(event.currentTarget)));
            Task.draggable(this.getDraggableAttr(realTaskHeight, this.realTaskWidth, Tab.GetFrame().find('table')));
            Task.resizable(this.getResizableAttr(realTaskHeight, Tab.GetFrame().find('table'), Color));
            resolve();
        });
        return promise1;
    }
    // args d'après requete dans Planning.DayAll.php
    // args = [ { "bbmindex": "", "datedebut: "", "datefin": "", "tache": "", "codetechnicien": "",
    //            "tripdistance": "", "triptemps": "", "tripdepassement": "",
    //            "triplastdistance: "", "triplasttemps": "", "triplastdepassement": "",
    //            "couleur": "" }, ... ]
    async loadAllTasks(args, flagNames) {
        /*Define cst*/
        var heightUnit = this.Unit;
        let tdToGetWidth = Tab.GetFrame().find('td:not(":first")')[0];
        this.realTaskWidth = parseInt($(tdToGetWidth).width());
        var argsCounter = args.length;
        var taskLength = 0;
        var taskHeight = 0;
        var htmlTaskTag = "";
        var htmlTaskHeaderTag = "";
        var htmlTaskHeaderClass = "";
        var htmlTaskHeaderText = "";
        var htmlTaskFlag = "";
        var thisObj = {};
        var taskBbmIndex = "";
        var taskStartDate = {};
        var taskEndDate = {};
        var taskText = "";
        var taskColor = "";
        var parentId = "";
        var taskParent = {};
        var parentTop = 0;
        var tableElement = Tab.GetFrame().find('table');
        let nomclientlivraison = '';
        let adresselivraison = '';
        let codepostallivraison = '';
        let villelivraison = '';
        let nomEtAdresseClient = '';
        let addressmatchValuesArray = ['zero'];
        let previousEndDate = null;
        let previousCodeTechnicien = null;
        let tacheAvecDossier = false;
        // Attention, il faut que cette liste soit ordonnee par technicien, par heure croissante
        for (var taskCounter = 0; taskCounter < argsCounter; taskCounter++) {
            //For each taskObject
            thisObj = args[taskCounter];
            nomclientlivraison = thisObj.nomclientlivraison !== null ? thisObj.nomclientlivraison : '';
            adresselivraison = thisObj.adresselivraison !== null ? thisObj.adresselivraison : '';
            codepostallivraison = thisObj.codepostallivraison !== null ? thisObj.codepostallivraison : '';
            villelivraison = thisObj.villelivraison !== null ? thisObj.villelivraison : '';
            nomEtAdresseClient = nomclientlivraison + ' - ' + adresselivraison + ' - ' + codepostallivraison + ' ' + villelivraison;
            // dans les anciennes bases, la valeur par defaut de la colonne numdossier
            // de la table planningweb est 0 => les taches creees sans dossier de rattachement
            // ont leur numdossier = 0
            if (thisObj.numdossier !== null && thisObj.numdossier !== '' && thisObj.numdossier !== 0) {
                tacheAvecDossier = true;
            }
            else {
                tacheAvecDossier = false;
            }
            // au 1er passage, on teste si les adresses de depart ou d'arrivee sont mauvaises
            if (this.tempsDistanceRight
                && taskCounter == 0
                && addressmatchValuesArray.indexOf(thisObj.startorendaddressmatch) !== -1) {
                // message d'erreur : adresse de depart ou d'arrivee invalide
                notify(window.wrongStartOrEndAddress);
            }
            taskStartDate = moment.utc(thisObj.datedebut);
            taskEndDate = moment.utc(thisObj.datefin);
            let heuresParse = thisObj.hdeb.split(":");
            // si on change de jour (affichage mode semaine, un technicien)
            // ou de technicien (affichage mode jour tous les techniciens)
            // => reinit previousEndDate = null
            // pour afficher la zone rouge entre l'heure de debut de journee
            // et l'heure de debut de la 1ere tache
            if ((previousEndDate !== null && !taskStartDate.isSame(previousEndDate, 'day'))
                || thisObj.codetechnicien != previousCodeTechnicien) {
                previousEndDate = null;
            }
            taskBbmIndex = thisObj.bbmindex;
            //Get task's length
            taskLength = moment.duration(taskEndDate - taskStartDate).asMinutes() / 15;
            taskHeight = taskLength * heightUnit;
            //Task's parent
            //Retrieving the right parent's ID
            parentId = this.dateToId(thisObj.datedebut, thisObj.codetechnicien);
            //And now the DOM parent
            taskParent = Tab.GetFrame().find('#' + parentId);
            if (taskParent.length === 0)
                continue;
            parentTop = $(taskParent).position().top;
            taskColor = thisObj.couleur;
            //Div's creation
            htmlTaskTag = "<div draggable='true' id='" + thisObj.bbmindex + "' class='tacheDay' style='top: " + parentTop + ";height:" + taskHeight + "px; width:" + this.realTaskWidth + "px; background-color:" + taskColor + "'>";
            /* thisObj.addressmatch peut prendre 3 valeurs en fonction du retour de l'api google maps
            * 'zero' : l'adresse n'a pas ete trouvee, pas de proposition
            * 'partial' : google maps ne trouve pas de correspondance avec une adresse existante,
            * 		mais en propose une (ex. centre de la ville). L'adresse proposee est stockee dans thisObj.formattedaddress
            * 'exact' : google maps trouve l'adresse exacte ou une correspondance avec une adresse existante (interpretation)
            */
            htmlTaskHeaderClass = 'task-header TaskTime';
            // une tache non liee a un dossier n'a pas d'adresse
            if (this.tempsDistanceRight
                && tacheAvecDossier
                && addressmatchValuesArray.indexOf(thisObj.addressmatch) !== -1) {
                htmlTaskHeaderClass += ' invalidAddress';
                // message d'erreur : adresse invalide
                notify(window.wrongTourAddress);
            }
            htmlTaskHeaderTag = "<div class='" + htmlTaskHeaderClass + "' style='margin-right: 0px;'>";
            htmlTaskHeaderText = this.TaskInfo(taskStartDate, taskEndDate, thisObj.triptemps, thisObj.tripdistance);
            taskText = thisObj.tache !== null ? thisObj.tache : "";
            let inTheRed = false;
            if (tacheAvecDossier && this.zonesRouges) {
                if (previousEndDate === null) {
                    inTheRed = moment.utc(thisObj.datedebut).hours(heuresParse[0]).minutes(heuresParse[1]).isAfter(moment.utc(thisObj.datedebut).subtract(parseInt(thisObj.triptemps, 10), 'seconds'));
                }
                else {
                    inTheRed = previousEndDate.isAfter(moment.utc(thisObj.datedebut).subtract(parseInt(thisObj.triptemps, 10), 'seconds'));
                }
            }
            if (inTheRed) {
                this.redByTrajet(moment.utc(thisObj.datedebut).hours(heuresParse[0]).minutes(heuresParse[1]), moment.utc(thisObj.datedebut), thisObj.codetechnicien, Math.ceil(moment.duration(parseInt(thisObj.triptemps, 10), 'seconds').asMinutes() / 15));
            }
            // on ignore les taches sans dossier pour l'affichage des zones rouges
            // = est-ce qu'on a le temps entre la tache courante et la tache precedente
            if (tacheAvecDossier) {
                previousEndDate = taskEndDate;
            }
            previousCodeTechnicien = thisObj.codetechnicien;
            /*Delete already used property*/
            /* on doit supprimer les elements qui ne seront pas utiles dans getFlagForAll : sinon crée des pastilles en trop ! */
            delete thisObj.activite;
            delete thisObj.bbmindex;
            delete thisObj.codetechnicien;
            delete thisObj.couleur;
            delete thisObj.datedebut;
            delete thisObj.datefin;
            delete thisObj.tache;
            delete thisObj.numdossier;
            delete thisObj.nomclientlivraison;
            delete thisObj.adresselivraison;
            delete thisObj.codepostallivraison;
            delete thisObj.villelivraison;
            delete thisObj.tripdistance;
            delete thisObj.triptemps;
            delete thisObj.tripdepassement;
            delete thisObj.addressmatch;
            delete thisObj.startorendaddressmatch;
            delete thisObj.formattedaddress;
            delete thisObj.triplastdistance;
            delete thisObj.triplasttemps;
            delete thisObj.triplastdepassement;
            delete thisObj.planningtriptotalindex;
            delete thisObj.totaldistance;
            delete thisObj.totaltpsdep;
            delete thisObj.totaltpsinter;
            delete thisObj.totaltpstotal;
            delete thisObj.totaldepassement;
            delete thisObj.hdeb;
            delete thisObj.nbheuresouvrables;
            /*Fin delete*/
            //Get flag DOM
            htmlTaskFlag = this.getFlagForAll(thisObj, flagNames);
            Tab.GetFrame()
                .find(taskParent)
                // pour l'affichage permanent du nom du client et de son adresse, independamment du texte libre
                // de la tache
                //.append(htmlTaskTag + htmlTaskHeaderTag + htmlTaskHeaderText + htmlTaskFlag + "</div><div>" + nomEtAdresseClient + "</div><text>" + taskText + "</text></div>");
                .append(htmlTaskTag + htmlTaskHeaderTag + htmlTaskHeaderText + htmlTaskFlag + "</div><text>" + taskText + "</text></div>");
            Tab.GetFrame().find('#' + taskBbmIndex)
                .draggable(this.getDraggableAttr(taskHeight, this.realTaskWidth, tableElement))
                .resizable(this.getResizableAttr(heightUnit, tableElement, taskColor))
                .bind("click", (event) => this.ShowTask($(event.currentTarget)));
        }
    }
    redByTrajet(dayStartHour, dateDebut, codetech, duree) {
        if (!this.zonesRouges)
            return;
        // Rougir les cases au dessus (15min par 15min)
        for (let i = 1; i <= duree; ++i) {
            dateDebut.subtract(15, "minutes");
            if (!dayStartHour.isAfter(dateDebut)) {
                let momentNewHourPart = dateDebut.format("YYYY-MM-DD HH:mm:ss");
                Tab.GetFrame().find("#" + this.dateToId(momentNewHourPart, codetech)).addClass("redTachePlanning");
            }
        }
    }
    endRedTask(objEnd) {
        for (let element of objEnd) {
            this.redByTrajet(moment.utc(element.dateDebut.date), element.codetech, element.duree);
        }
    }
    /**!lk
     * Affichage des informations sur la tache
     * @param {type} TaskId Identifiant de la tache
     * @returns {undefined}
     */
    ShowTaskById(TaskId) {
        var Task = Tab.GetFrame().find("#" + TaskId);
        this.ShowTask(Task);
    }
    /**
     * Affichage des informations sur la tache
     * @param Task div lié à la tache selectionnée
     */
    ShowTask(Task) {
        Task = $(Task);
        if (!Task.hasClass('tacheWeek')
            && !Task.hasClass("tacheDay")) {
            Task = Task.parents(".tacheDay").length !== 0 ? Task.parents(".tacheDay") : Task;
        }
        if (Task.length === 0) {
            return;
        }
        if (Task.hasClass('ui-draggable-dragged')) {
            Task.removeClass("ui-draggable-dragged");
            return;
        }
        if (Task.hasClass('ui-draggable-dragging'))
            return;
        let taskId = Task.attr("id");
        if (typeof taskId === 'undefined')
            return;
        let numcontent = Tab.cTab.attr('id');
        let pTargetId = "modalIframe";
        // action formulaire 'planningtache'
        let numAction = '8038';
        // 6eme argument = setTabText : mettre à jour le texte de l'onglet courant ? false si le formulaire est dans une popup
        Form.requestFormulaire(numcontent, pTargetId, numAction, taskId, '', false);
        openModalIframe(null, LBL_TACHE);
    }
    /**
     * Deleting the current task or the linked tasks (having been duplicated)
     * starting from the current task date
     * @param {int} Id Task identifier
     * @param {boolean} duplicates
     * @returns {undefined}
     */
    async Delete(Id, duplicates = false) {
        await Ajax.Post({
            url: "_module/Planning/Planning.Week.Delete.php",
            data: "planningweb=" + Id + "&duplicates=" + duplicates,
            json: true,
            success: (xml) => {
                closeModalIframe();
                Process(8135, json2array(xml), null, null).then(() => this.totalRefresh());
            }
        });
    }
    /**
     * Delete the current task or the linked tasks (having been duplicated)
     * starting from the current task date
     * @param {number} Id Task identifier
     * @param {number} linked_tasks_id
     * @returns {undefined}
     */
    DeleteTaskOrDuplicates(Id, linked_tasks_id = null) {
        if (linked_tasks_id !== null && linked_tasks_id !== '') {
            bootbox.dialog({
                message: MSG_TASK_DELETE_ONE_OR_DUPLICATES,
                buttons: {
                    cancel: {
                        label: CMD_CANCEL
                    },
                    taskOnly: {
                        label: CMD_TASK_DELETE_ONE,
                        callback: function () {
                            Seed.Planning.Delete(Id, false);
                        }
                    },
                    duplicates: {
                        label: CMD_TASK_DELETE_DUPLICATES,
                        callback: function () {
                            Seed.Planning.Delete(Id, true);
                        }
                    }
                }
            });
        }
        else {
            this.Delete(Id, false);
        }
    }
    /**
     * Mise à jour du commentaire de la tache
     * @param Id Identifiant du planningweb
     * @param TaskText Commentaire
     * @param activite type d'activité
     */
    async UpdateTask(Id, taskText, activite) {
        if (taskText !== null || activite !== null) {
            await Ajax.Post({
                url: "_module/Planning/Planning.Update.Task.php",
                data: "planningweb=" + Id
                    + (taskText !== null ? "&task=" + encodeURIComponent(taskText) : '')
                    + (activite !== null ? "&activite=" + encodeURIComponent(activite) : '')
            });
            delete this.currentTask.currentLength;
            this.Refresh(Id);
        }
    }
    async UpdateTime(Id) {
        await Ajax.Post({
            url: "_module/Planning/Planning.Update.Time.php",
            data: "planningweb=" + Id
        });
    }
    /**
     * Save a task at new start and end dates
     * or duplicate this task between the start and end dates
     * @param {number} taskId Task identifier
     * @param {string} newEndDateStr task end date as a string
     * @param {string} newEndTimeStr task end time as a string
     * @param {string} newStartDateStr task start date as a string
     * @param {string} newStartTimeStr task start time as a string
     * @param {string} codetechnicienStr value of 'codetechnicien' in the 'planningweb' table
     * @param {number} linked_tasks_id identifier linking the tasks created from a duplication
     * @returns {undefined}
     */
    async saveTaskFromForm(taskId, newEndDateStr, newEndTimeStr = '', newStartDateStr = '', newStartTimeStr = '', codetechnicienStr = '', linked_tasks_id = null) {
        await Ajax.Post({
            url: '_module/Planning/Planning.SaveTask.php',
            data: "id=" + taskId
                + "&day=" + newStartDateStr
                + "&savetaskfromform=1"
                + "&enddatetime=" + newEndDateStr + ' ' + newEndTimeStr
                + "&hours=" + newStartTimeStr + ',' + newEndTimeStr
                + (codetechnicienStr !== '' ? "&codetechnicien=" + codetechnicienStr : '')
                + (linked_tasks_id !== null ? "&linked_tasks_id=" + linked_tasks_id : ''),
            json: true,
            success: (xml) => {
                // the task is movable if the file is not closed,
                // if the start and end hours are consistent
                // and if there is no task overlap
                if (xml.taskLength !== -1
                    && (xml.dossierclos == 0 || xml.dossierclos == null)) {
                    if (xml.tasks2addNb > 0) {
                        if (xml.addedTasksNb != xml.tasks2addNb) {
                            bootbox.alert(MSG_TASK_NO_DUPLICATION_ON_NON_WORKING_DAYS);
                        }
                    }
                    closeModalIframe();
                    Process(8136, json2array(xml), null, null).then(() => this.totalRefresh(this.GetNumDossier()));
                }
                else {
                    bootbox.alert(xml.errorMsg + ' ' + xml.collidingDateArray);
                }
            }
        });
    }
    async FinishTask(Id) {
        await Ajax.Post({
            url: "_module/Planning/Planning.Finish.Task.php",
            data: "planningweb=" + Id
        });
    }
    async FinishAllTask(dateDebut, dateFin) {
        await Ajax.Post({
            url: "_module/Planning/Planning.Finish.AllTask.php",
            data: "dateDebut=" + dateDebut
                + "&dateFin=" + dateFin,
            success: Tab.Reload
        });
    }
    /**
     * Parse the DateTime string to return a string with just the date
     * @param {type} dataTask
     * @returns {nm$_this.Seed_Planning_L20.this.dateParser.date}
     */
    dateParser(dataTask) {
        var dateString = dataTask.date;
        var partsArray = dateString.split('x');
        var date = partsArray[0];
        return date;
    }
    /**
     * Set locking value for Planning and basket
     * @param {bool} value Value to set
     */
    setLock(value) {
        this.Lock[Tab.cTab.attr("id")] = value;
    }
    /**
     * Get state for lock
     * @returns {bool} Return value of Lock
     */
    getLock() {
        return this.Lock[Tab.cTab.attr("id")];
    }
    /**
     * Active où désactive le planning
     */
    locking() {
        var isLocked = this.getLock();
        var canvas = Tab.GetFrame().find('.canvas-parent');
        if (isLocked) {
            // Le cacher
            $(canvas).removeClass('canvas-locked');
            this.lockingJqueryUI(true);
        }
    }
    resizeTask() {
        this.taskWidth = parseInt(Tab.GetFrame().find('tbody').children('tr.droppable:first').children(':first').width());
        this.realTaskWidth = this.taskWidth;
        Tab.GetFrame().find('.tacheDay').each((index, elem) => {
            $(elem).css("width", this.taskWidth + 2),
                $(elem).draggable({
                    grid: [this.taskWidth, this.Unit]
                });
        });
    }
    /**
     * Redimentionne la taille du calendrier
     */
    calendarSize() {
        var windowHeight = $(document).height();
        var planningHeight = windowHeight - $('.topbar').height() - $('.EnTeteModule').height() - $('.navbar-fixed-bottom').height() - 232;
        Tab.GetFrame().find("#Planning").css('width', '100%');
        Tab.GetFrame().find("#Planning").css('height', planningHeight + 'px');
    }
    toggleFly(domElem) {
        if (toggleFlyPath(!window.displayBirdFly, true)) {
            window.displayBirdFly = !window.displayBirdFly;
            $(domElem).toggleClass("btn-primary").toggleClass("btn-default").toggleClass("active");
        }
    }
    toggleTraffic(domElem) {
        if (window.displayTraffic) {
            $(domElem).addClass("btn-default").removeClass("btn-primary active");
        }
        else {
            $(domElem).addClass("btn-primary active").removeClass("btn-default");
        }
        toggleTraffic(!window.displayTraffic);
        window.displayTraffic = !window.displayTraffic;
    }
    /**
     * Active où désactive UI Draggable option
     * @param  {boolean} bool
     */
    lockingJqueryUI(bool) {
        let attrFromBool = bool ? "enable" : "disable";
        // Tache
        $(".tacheDay").draggable(attrFromBool);
        $(".tacheDay").resizable(attrFromBool);
        $(".selectable").selectable(attrFromBool);
        // Panier
        var calendarMode = this.GetMode();
        if (calendarMode === "jour" || calendarMode === "jourdetail" || calendarMode === "semainedetail") {
            Tab.GetFrame().find(".taskDrop").draggable(attrFromBool);
        }
        else {
            Tab.GetFrame().find(".taskDrop").draggable("disable");
        }
    }
    hideCart() {
        var panel = Tab.GetFrame().find('#planning-wrapper');
        $(panel).find('.task-panel').hide();
        $(panel).find('.planning-panel').addClass('col-sm-12').removeClass('col-sm-10');
    }
    showCart() {
        var panel = Tab.GetFrame().find('#planning-wrapper');
        $(panel).find('.task-panel').show();
        $(panel).find('.planning-panel').addClass('col-sm-10').removeClass('col-sm-12');
    }
    toogleCart() {
        if (this.isCartVisible()) {
            var panel = Tab.GetFrame().find('#planning-wrapper');
            $(panel).find('.task-panel').toggle();
            $(panel).find('.planning-panel').toggleClass('col-sm-12 col-sm-10');
        }
        else {
            this.hideCart();
        }
    }
    isCartVisible() {
        var isVisible = false;
        var mode = this.GetMode();
        var isCartVisible = (mode === "jour" || mode === "semainedetail" || mode === "jourdetail");
        if (this.planning_cart && (this.getLock() && isCartVisible)) {
            isVisible = true;
        }
        return isVisible;
    }
    getTechnicien() {
        return Tab.GetFrame().find('#technicien').val();
    }
    getSkill() {
        return Tab.GetFrame().find('#skill').val();
    }
    /**
     * Retourne la date de référence
     * @returns {string} Date de référence du planning
     */
    GetDate() {
        return this.Date[Tab.cTab.attr("id")];
    }
    /**
     * Transform an id from planning to a date
     * @param {string} id ID int the planning
     * @returns {Date} Returns the date
     */
    idToDate(id) {
        var separatedId = id.split('-');
        var idStr = separatedId[0].split('x');
        idStr[0] = idStr[0].replace(/_/g, '-');
        idStr[1] = idStr[1].replace(/_/g, ':');
        var dateISO = idStr[0] + ' ' + idStr[1];
        var date = moment.utc(dateISO);
        return date.format('YYYY-MM-DD HH:mm:ss');
    }
    /**
     * Transform a date from planning to an id
     * @param {string} dateString string of type date
     * @param {string} codeTech string contains codetech
     * @returns {id} Returns the id relative to this date
     */
    dateToId(dateString, codeTech) {
        var idWithoutCodeTech = dateString.replace(/-/g, '_')
            .replace(/:/g, '_')
            .replace(' ', 'x');
        var codeTechEscaped = escapeSelector(codeTech);
        return idWithoutCodeTech + "-" + codeTechEscaped;
    }
    getLengthOnResize(event, ui) {
        let $eventTarget = $(event.target);
        let actualTaskLength = Math.ceil($eventTarget.height() / 17);
        // find the new task's parent (the planning grid's 'td' element representing the starting day and hour of the task)
        // by counting the number of grid vertical units ('tr' elements) spanned by changing the task's size
        let $gridOldTaskTdParent = $eventTarget.parent();
        let gridOldTdIndex = $gridOldTaskTdParent.index();
        let $gridOldTaskTrParent = $gridOldTaskTdParent.parent();
        // height of the 'tr' element, parent of the 'td' element which is the parent of the task.
        // All the 'tr' elements have the same height (time grid)
        let gridTrHeight = $gridOldTaskTrParent.height();
        // number of 'tr' elements between the original top position of the task and its new top position
        let gridTrNb2Span = (ui.originalPosition.top - ui.position.top) / gridTrHeight;
        gridTrNb2Span = gridTrNb2Span < 0 ? Math.floor(gridTrNb2Span) : Math.ceil(gridTrNb2Span);
        // position of the tr element which is the parent of the task's parent (td), relatively to its parent (tbody of the planning table)
        let gridOldTrIndex = $gridOldTaskTrParent.index();
        // shifting the tr's index by the number of tr which don't have the right height
        // (there are tr elements which have their height = 0 only for styling purposes)
        let $gridAllTrElements = $gridOldTaskTrParent.parent().children();
        let $gridTrElementsBelowOldTrIndex = $gridAllTrElements.filter(function (index) { return index <= gridOldTrIndex; });
        let trNbBelowOldTrIndex2Shift = $gridTrElementsBelowOldTrIndex.filter(function () { return $(this).height() != gridTrHeight; }).length;
        gridOldTrIndex -= trNbBelowOldTrIndex2Shift;
        let $gridTrElementsWithRightHeight = $gridAllTrElements.filter(function () { return $(this).height() == gridTrHeight; });
        // position of the tr element which will be the parent of the new task's parent (td)
        let gridNewTrIndex = gridOldTrIndex - gridTrNb2Span;
        // new task's parent (td)
        let $gridNewTaskTrParent = $gridTrElementsWithRightHeight.eq(gridNewTrIndex);
        let $gridNewTaskTdParent = $gridNewTaskTrParent.children().eq(gridOldTdIndex);
        this.currentTask.realParent = $gridNewTaskTdParent;
        if (Tab.GetFrame().find(this.currentTask.realParent).hasClass('disabled') || Tab.GetFrame().find(this.currentTask.realParent).hasClass('tacheDay') || ui.position.top < $('.EnteteTechnicienPlanning:first').parent().height() - 5) {
            actualTaskLength = this.currentTask.originalLength;
        }
        return actualTaskLength;
    }
    async totalRefresh(numdossier) {
        numdossier = typeof numdossier !== 'undefined' ? numdossier : '';
        refreshPlanningAndList(numdossier, this.GetDate(), this.GetMode(), this.GetSecteur(), '', this.getTechnicien(), '', this.getSkill());
    }
    /**
     * Function to append bubbles to task
     * @param {string} id
     * @param {array} past1
     * @param {array} past2
     * @param {array} past3
     *
     * @todo : async/await, sync ajax
     */
    async appendPastile(id, flagData) {
        var rowX = document.createElement("DIV");
        rowX.setAttribute("class", "row pastilleParent");
        rowX.setAttribute("id", "pastille" + id);
        Tab.GetFrame().find('#' + escapeSelector(id)).children('.task-header').append(rowX);
        var test = "";
        if (!flagData) {
            test = await Ajax.Post({
                url: "_module/Planning/Planning.GetFlag.php",
                data: "id=" + id
                    + "&isFromSeedPlanning=true",
                type: 'POST'
            });
        }
        else {
            test = JSON.parse(flagData);
        }
        var flagProp = "";
        var titleString = "";
        var color = "";
        var splittedKey = "";
        var titleValue = "";
        var propTable = "";
        for (var key in test.flagNames) {
            splittedKey = key.split('_');
            titleString = test.flagNames[key];
            for (var prop in test.flagResult) {
                if (prop.endsWith(splittedKey[1]) && !prop.startsWith('value')) {
                    propTable = prop.split('_');
                    color = test.flagResult[propTable[0] + '_couleur'];
                    if (test.flagResult['value_' + splittedKey[1]] !== null) {
                        titleValue = (test.flagResult[prop] !== 'null' && test.flagResult[prop] !== null) ? test.flagResult[prop] : test.flagResult['value_' + splittedKey[1]];
                    }
                    else {
                        titleValue = "";
                    }
                    titleString = titleString + ' : ' + titleValue;
                }
            }
            flagProp = [titleString, color];
            this.appendFlag(id, flagProp);
        }
    }
    appendFlag(id, flagAttr) {
        var flagElement = document.createElement("SPAN");
        flagElement.setAttribute("class", "col-sm-1 pastille");
        flagElement.setAttribute("title", flagAttr[0]);
        flagElement.setAttribute("style", "background-color:" + flagAttr[1]);
        Tab.GetFrame().find('#pastille' + escapeSelector(id) + ':not(".clone")').append(flagElement);
    }
    getFlagForAll(flagData, flagNames) {
        var rowContainer = "<div class='row pastilleParent'>";
        var splittedProp = [];
        var spanContainer = "";
        var bgColor = "";
        var myTitle = "";
        var propValue = "";
        for (var prop in flagData) {
            if (!prop.startsWith('value') && !prop.endsWith('couleur')) {
                splittedProp = prop.split('_', 3);
                bgColor = (flagData[prop] !== null || flagData["value_" + splittedProp[2]]) ? flagData[splittedProp[0] + '_' + splittedProp[1] + '_couleur'] : "";
                flagData["value_" + splittedProp[2]] = flagData["value_" + splittedProp[2]] !== null ? flagData["value_" + splittedProp[2]] : "";
                propValue = flagData[prop] !== null ? flagData[prop] : flagData["value_" + splittedProp[2]];
                myTitle = flagNames["trad_" + splittedProp[2]] + " : " + propValue;
                spanContainer += "<span class='col-sm-1 pastille' title='" + myTitle + "'"
                    + " style='" + (bgColor != '' ? "background-color: " + bgColor + ";" : "background-image: url(\"style/diagonal.png\");") + "'></span>";
            }
        }
        return rowContainer + spanContainer + "</div>";
    }
    getDraggableAttr(taskHeight, taskWidth, tableElement) {
        var draggableAttr = {
            grid: [taskWidth, taskHeight],
            containment: tableElement,
            snap: "td.Hour-day",
            helper: (event) => {
                let myClone = $(event.target).children(':first').clone();
                myClone.children(':first').addClass('clone');
                myClone.css('width', this.realTaskWidth);
                return myClone;
            },
            start: (event, ui) => {
                this.currentTask.task = $(event.target);
                this.currentTask.currentLength = Math.ceil(this.currentTask.task.height() / 17);
                if (this.currentTask.task.hasClass('tacheDay')) {
                    this.currentTask.isFrom = "planning";
                }
            },
            cursorAt: { top: 0 },
            stop: (event, ui) => {
                if (this.currentTask.isFrom === "planning") {
                    if (this.currentTask.hasBeenDropped === true) {
                        var myTd = this.taskParent;
                        $(myTd).append(event.target);
                        delete this.currentTask.isFrom;
                        this.currentTask.hasBeenDropped = false;
                        this.SaveTask(event.target).then(() => this.totalRefresh());
                    }
                    else {
                        bootbox.alert('Affectation impossible!');
                        this.Refresh(this.id);
                    }
                }
            }
        };
        return draggableAttr;
    }
    getResizableAttr(taskHeight, tableElement, taskColor) {
        var resizableAttr = {
            grid: taskHeight,
            handles: 's, n',
            containment: tableElement,
            start: (event, ui) => {
                $(this).css("background-color", "red");
                $(this).css("opacity", "0.5");
                $(this).css("color", "white");
                $(this).addClass("ui-draggable-dragged");
                this.currentTask.originalEvent = event.target;
                this.currentTask.originalLength = Math.ceil($(event.target).height() / 17);
                this.currentTask.originalWidth = $(event.target).width();
            },
            resize: (event, ui) => {
                ui.size.width = this.currentTask.originalWidth;
                ui.helper = this.currentTask.originalEvent;
            },
            stop: (event, ui) => {
                this.currentTask.currentLength = this.getLengthOnResize(event, ui);
                var dataTask = {
                    'day': Tab.GetFrame().find(this.currentTask.realParent).attr("data-date"),
                    'numDay': Tab.GetFrame().find(this.currentTask.realParent).attr("data-numDay"),
                    'codeTech': Tab.GetFrame().find(this.currentTask.realParent).attr("data-tech")
                };
                if (dataTask.day && dataTask.codeTech) {
                    // on passe le numero du dossier a la fonction de rafraichissement pour pouvoir replanifier
                    // si planif en cours
                    this.SaveTask(event.target).then(this.totalRefresh(this.GetNumDossier()));
                    delete this.currentTask.currentLength;
                }
                else {
                    bootbox.alert('Affectation impossible!');
                    this.Refresh(this.id);
                    delete this.currentTask.currentLength;
                }
                $(event.target).css("background-color", taskColor);
                $(event.target).css("opacity", "0.8");
                $(event.target).css("color", "black");
                $(event.target).addClass("ui-draggable-dragged");
            }
        };
        return resizableAttr;
    }
    getSelectableAttr(pDate, pCodetechnicien, pSecteur, tacheStdOrDetail, planningTypeSemaine) {
        var selectableAttr = {
            filter: "td",
            start: (event, ui) => {
                delete this.currentTask.currentLength;
                if (Tab.GetFrame().find(event.originalEvent.target).hasClass('disabled')) {
                    this.isWrongSelect = true;
                }
                else {
                    this.isWrongSelect = false;
                }
            },
            selected: (event, ui) => {
                if (this.currentTask.realParent === undefined) {
                    this.currentTask.realParent = ui.selected;
                }
            },
            stop: async (event, ui) => {
                if (!Tab.GetFrame().find(this.currentTask.realParent).hasClass('disabled') && !this.isWrongSelect && Tab.GetFrame().find(this.currentTask.realParent).prop('tagName') === 'TD') {
                    let numDossier = this.GetNumDossier();
                    var nbhour = 0;
                    var firstspan = null;
                    Tab.GetFrame().find(".ui-selected").each((index, elem) => {
                        if (nbhour === 0) {
                            firstspan = $(elem);
                        }
                        nbhour++;
                    });
                    if (firstspan !== null) {
                        // le code technicien peut contenir un '-'
                        // => après le split, la 1ère partie est l'heure, le reste est le code technicien
                        var hourAndId = firstspan.attr("id").split('-');
                        var hour = hourAndId[0];
                        var codetechnicien = hourAndId.slice(1).join('-');
                        if (this.Clipboard === null) {
                            var xml = await Ajax.Post({
                                url: "_module/Planning/Planning.Week.CreateTask.php",
                                data: "hour=" + hour
                                    + "&length=" + nbhour
                                    + "&codetechnicien=" + codetechnicien
                                    + "&dossier=" + numDossier,
                                json: true
                            });
                            if (xml.taskLength === -1) {
                                bootbox.alert(xml.errorMsg);
                            }
                            else {
                                // on passe le numero du dossier a la fonction de rafraichissement pour pouvoir replanifier
                                Process(3030, json2array(xml), null, null).then(() => this.totalRefresh(numDossier));
                            }
                        }
                        else {
                            firstspan.text("");
                            var Task = this.Clipboard;
                            var parent = Tab.GetFrame().find(".ui-selectee", this).parent();
                            parent.append(Task);
                            let datesTask = this.GetStartHour($(Task), this.currentTask.currentLength);
                            $(Task).find(".task-header").html(this.TaskInfo(datesTask[0], datesTask[1], this.currentTask.currentLength));
                            this.SaveTask(Task).then(() => {
                                this.Clipboard = null;
                                if (this.GetMode() === "jourdetail" || this.GetMode() === "jour") {
                                    this.LoadDayAll(pDate, pCodetechnicien, numDossier, pSecteur, '');
                                }
                                else if ((this.GetMode() === "semaine") || (this.GetMode() === "semainedetail")) {
                                    this.LoadWeek(pDate, pCodetechnicien, numDossier, pSecteur, tacheStdOrDetail, planningTypeSemaine);
                                }
                            });
                        }
                    }
                    Tab.GetFrame().find(".ui-selected", this).removeClass("ui-selected");
                }
            }
        };
        return selectableAttr;
    }
    getDateTimeMoment(dateTimeStr) {
        let dateTimeMoment = moment.utc(dateTimeStr, 'YYYY-MM-DD HH:mm:ss', true);
        if (!dateTimeMoment.isValid()) {
            dateTimeMoment = moment.utc(dateTimeStr, "L LTS");
        }
        return dateTimeMoment;
    }
    /**
     * Create and open a bootbox dialog
     * to choose the end date for the task duplication
     * @param {number} taskId Task identifier
     * @param {string} endDateTimeStr task end date as a string
     * @returns {void}
     */
    createAndOpenDuplicationDialog(taskId, endDateTimeStr) {
        const endDateTimeMoment = this.getDateTimeMoment(endDateTimeStr);
        const endDateStr = endDateTimeMoment.format('L');
        let datetimepickerDateOptionsObj = {
            locale: moment.locale(),
            icons: {
                time: 'fa fa-clock-o',
                date: 'fa fa-calendar-o',
                up: 'fa fa-arrow-up',
                down: 'fa fa-arrow-down',
                previous: 'fa fa-angle-left',
                next: 'fa fa-angle-right',
                today: 'fa fa-crosshairs',
                clear: 'fa fa-trash'
            },
            showTodayButton: true,
            showClear: true,
            format: "L",
            useCurrent: false
        };
        let bootboxHtml = '<div id="bootbox_duplicate_task" class="container-fluid">\
			<label for="bootbox_duplicate_end_date">Date Fin :</label>\
			<input type="text" id="bootbox_duplicate_end_date" name="bootbox_duplicate_end_date" value="' + endDateStr + '"/>\
			</div>';
        bootbox.confirm(bootboxHtml, function (result) {
            if (result) {
                let newEndDateStr = $('#bootbox_duplicate_end_date').val();
                // verifying that we have a valid date
                if (Seed.Planning.taskDateValidation(newEndDateStr)) {
                    let newEndDateMoment = Seed.Planning.getDateTimeMoment(newEndDateStr);
                    newEndDateStr = newEndDateMoment.format('YYYY-MM-DD');
                    if (!endDateTimeMoment.isSame(newEndDateMoment, 'day')) {
                        Seed.Planning.saveTaskFromForm(taskId, newEndDateStr);
                    }
                    else {
                        bootbox.alert(MSG_TASK_NO_DUPLICATION);
                    }
                }
            }
        });
        $("#bootbox_duplicate_end_date").datetimepicker(datetimepickerDateOptionsObj);
    }
    /**
     * Create and open a bootbox dialog
     * enabling to choose the start date for the task shift
     * and also new task hours, and a new technician
     * @param {number} taskId Task identifier
     * @param {string} startDateTimeStr task start date as a string
     * @param {string} endDateTimeStr task end date as a string
     * @param {document} codetechnicienDomElement references the 'codetechnicien' select list from the task popup
     * @param {number} linked_tasks_id identifies the tasks created from a duplication
     * @returns {void}
     */
    createAndOpenShiftDialog(taskId, startDateTimeStr, endDateTimeStr, codetechnicienDomElement, linked_tasks_id = null) {
        let startDateTimeMoment = this.getDateTimeMoment(startDateTimeStr);
        let startDateStr = startDateTimeMoment.format('L');
        let startTimeStr = startDateTimeMoment.format('LT');
        let endDateTimeMoment = this.getDateTimeMoment(endDateTimeStr);
        let endTimeStr = endDateTimeMoment.format('LT');
        let $codetechnicienDomElement = $(codetechnicienDomElement);
        let codetechnicienStr = $codetechnicienDomElement.val();
        let datetimepickerDateOptionsObj = {
            locale: moment.locale(),
            icons: {
                time: 'fa fa-clock-o',
                date: 'fa fa-calendar-o',
                up: 'fa fa-arrow-up',
                down: 'fa fa-arrow-down',
                previous: 'fa fa-angle-left',
                next: 'fa fa-angle-right',
                today: 'fa fa-crosshairs',
                clear: 'fa fa-trash'
            },
            showTodayButton: true,
            showClear: true,
            format: "L",
            useCurrent: false
        };
        // cloning the date object into a time object
        let datetimepickerTimeOptionsObj = $.extend(true, {}, datetimepickerDateOptionsObj);
        datetimepickerTimeOptionsObj.format = 'LT';
        let bootboxContainerHtml = '<div id="bootbox_shift_task" class="container-fluid">\
			<label for="bootbox_shift_start_date">Date :</label>\
			<input type="text" id="bootbox_shift_start_date" name="bootbox_shift_start_date" value="' + startDateStr + '"/>\
			<label for="bootbox_shift_start_hour">Heure début :</label>\
			<input type="text" id="bootbox_shift_start_hour" name="bootbox_shift_start_hour" value="' + startTimeStr + '"/>\
			<label for="bootbox_shift_end_hour">Heure fin :</label>\
			<input type="text" id="bootbox_shift_end_hour" name="bootbox_shift_end_hour" value="' + endTimeStr + '"/>\
			<label for="bootbox_shift_codetechnicien">Code technicien :</label>\
			<select id="bootbox_shift_codetechnicien" name="bootbox_shift_codetechnicien"></select>\
			</div>';
        bootbox.confirm(bootboxContainerHtml, function (result) {
            if (result) {
                let newStartDateStr = $('#bootbox_shift_start_date').val();
                let newStartTimeStr = $('#bootbox_shift_start_hour').val();
                let newStartDateTimeStr = newStartDateStr + ' ' + newStartTimeStr;
                let newEndTimeStr = $('#bootbox_shift_end_hour').val();
                let newEndDateTimeStr = newStartDateStr + ' ' + newEndTimeStr;
                let newCodetechnicienStr = $('#bootbox_shift_codetechnicien').val();
                // verifying that we have valid dates
                if (Seed.Planning.taskDateValidation(newStartDateTimeStr, newEndDateTimeStr)) {
                    let newStartDateTimeMoment = Seed.Planning.getDateTimeMoment(newStartDateTimeStr);
                    let newEndDateTimeMoment = Seed.Planning.getDateTimeMoment(newEndDateTimeStr);
                    // working with 15 minutes slices
                    newStartDateTimeMoment.minute(Math.round(newStartDateTimeMoment.minute() / 15) * 15);
                    newEndDateTimeMoment.minute(Math.round(newEndDateTimeMoment.minute() / 15) * 15);
                    if (!startDateTimeMoment.isSame(newStartDateTimeMoment, 'minute')
                        || !endDateTimeMoment.isSame(newEndDateTimeMoment, 'minute')
                        || codetechnicienStr !== newCodetechnicienStr) {
                        let newEndDateStr = newEndDateTimeMoment.format('YYYY-MM-DD');
                        newEndTimeStr = newEndDateTimeMoment.format('HH:mm');
                        newStartDateStr = newStartDateTimeMoment.format('YYYY-MM-DD');
                        newStartTimeStr = newStartDateTimeMoment.format('HH:mm');
                        Seed.Planning.saveTaskFromForm(taskId, newEndDateStr, newEndTimeStr, newStartDateStr, newStartTimeStr, newCodetechnicienStr, linked_tasks_id);
                    }
                    else {
                        bootbox.alert(MSG_TASK_NO_SHIFT);
                    }
                }
            }
        });
        $("#bootbox_shift_start_date").datetimepicker(datetimepickerDateOptionsObj);
        $("#bootbox_shift_start_hour").datetimepicker(datetimepickerTimeOptionsObj);
        $("#bootbox_shift_end_hour").datetimepicker(datetimepickerTimeOptionsObj);
        $codetechnicienDomElement.find('option').clone().appendTo("#bootbox_shift_codetechnicien");
    }
    /**
     * Validate dates (for a task) :
     * the argument strings must be valid dates.
     * If two arguments are provided, the end date must be after the start date.
     * @param {string} startDateTimeStr task start date as a string
     * @param {string} endDateTimeStr task end date as a string. Defaults to an empty string
     * @returns {boolean}
     */
    taskDateValidation(startDateTimeStr, endDateTimeStr = '') {
        let startDateTimeMoment = this.getDateTimeMoment(startDateTimeStr);
        let endDateTimeMoment = (endDateTimeStr !== '' ? this.getDateTimeMoment(endDateTimeStr) : {});
        let areBothDatesValid = false;
        if (startDateTimeMoment.isValid()
            && (endDateTimeStr === '' || endDateTimeMoment.isValid())) {
            if (endDateTimeStr === '' || endDateTimeMoment.isAfter(startDateTimeMoment)) {
                areBothDatesValid = true;
            }
            else {
                bootbox.alert(MSG_TASK_START_BEFORE_END);
            }
        }
        else {
            bootbox.alert(MSG_INVALID_DATE);
        }
        return areBothDatesValid;
    }
    /**
     * Shift the current task
     * or the linked tasks from the current task
     * @param {number} taskId Task identifier
     * @param {string} startDateTimeStr task start date as a string
     * @param {string} endDateTimeStr task end date as a string
     * @param {document} codetechnicienDomElement references the 'codetechnicien' select list from the task popup
     * @param {number} linked_tasks_id identifies the tasks created from a duplication
     * @returns {void}
     */
    shiftTasks(taskId, startDateTimeStr, endDateTimeStr, codetechnicienDomElement, linked_tasks_id = null) {
        // other tasks are linked to this one :
        // do we only shift this task or do we shift all the linked tasks from this one ?
        if (linked_tasks_id !== null && linked_tasks_id !== '') {
            bootbox.dialog({
                message: MSG_TASK_SHIFT_ONE_OR_DUPLICATES,
                buttons: {
                    cancel: {
                        label: CMD_CANCEL
                    },
                    taskOnly: {
                        label: CMD_SHIFT_ONE,
                        callback: function () {
                            Seed.Planning.createAndOpenShiftDialog(taskId, startDateTimeStr, endDateTimeStr, codetechnicienDomElement, null);
                        }
                    },
                    duplicates: {
                        label: CMD_SHIFT_DUPLICATES,
                        callback: function () {
                            Seed.Planning.createAndOpenShiftDialog(taskId, startDateTimeStr, endDateTimeStr, codetechnicienDomElement, linked_tasks_id);
                        }
                    }
                }
            });
        }
        else {
            Seed.Planning.createAndOpenShiftDialog(taskId, startDateTimeStr, endDateTimeStr, codetechnicienDomElement, null);
        }
    }
    ShowDossier(numDossier) {
        Process(1012, new Array(new Array('numdossier', numDossier)));
        closeModalIframe();
    }
}
;
export default new Planning();
//# sourceMappingURL=Seed.Planning.js.map